import { Camera } from "lucide-react";

export const Photo = ({ src, alt, className = "", label = "Photo of Shabz", testid }) => {
  if (src) {
    return (
      <img
        src={src}
        alt={alt}
        loading="lazy"
        data-testid={testid}
        className={`object-cover ${className}`}
      />
    );
  }
  return (
    <div
      data-testid={testid}
      role="img"
      aria-label={alt || label}
      className={`relative flex items-center justify-center overflow-hidden bg-[#141416] ${className}`}
    >
      <div
        className="absolute inset-0 opacity-[0.14]"
        style={{ background: "radial-gradient(circle at 50% 25%, #d4af37, transparent 62%)" }}
      />
      <div
        className="absolute inset-0 opacity-[0.5]"
        style={{ background: "repeating-linear-gradient(135deg, transparent 0 14px, rgba(255,255,255,0.015) 14px 15px)" }}
      />
      <div className="absolute inset-3 border border-[#d4af37]/25" />
      <div className="relative z-10 flex flex-col items-center gap-3 px-6 text-center">
        <Camera className="h-7 w-7 text-[#d4af37]" strokeWidth={1.1} />
        <span className="font-['IBM_Plex_Mono'] text-[10px] uppercase tracking-[0.34em] text-[#a1a1aa]">
          {label}
        </span>
      </div>
    </div>
  );
};
